export default __webpack_public_path__ + "static/media/ONG.aa68da30.svg";